"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InfoCardImage = function InfoCardImageComponent(_ref) {
  var image = _ref.image,
      link = _ref.link,
      alt = _ref.alt;

  if (!image.url || !link.url || alt.length === 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
    className: "content-page__info-card-image-link",
    href: link.url,
    external: link.target === '_blank'
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "content-page__info-card-image",
    srcSet: image.url,
    src: image.url,
    alt: alt[0].text
  }));
};

InfoCardImage.propTypes = {
  image: _propTypes["default"].shape({
    url: _propTypes["default"].string
  }).isRequired,
  link: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    target: _propTypes["default"].string
  }).isRequired,
  alt: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired
  })).isRequired
};
var _default = InfoCardImage;
exports["default"] = _default;